module.exports = __webpack_public_path__ + "static/img/fassadev1.19b4259.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/handwerk/fassadev1.jpg
// module id = Y89U
// module chunks = 1